export default __webpack_public_path__ + "static/media/Daniel_Headshot.0e6e1f5c.jpg";